import { render, staticRenderFns } from "./IntegrationsMachship.vue?vue&type=template&id=afcfdc44"
import script from "./IntegrationsMachship.vue?vue&type=script&lang=js"
export * from "./IntegrationsMachship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports